/* Wave 12.18 (Vania 1 Oct) · /terms — public, no sign-in required. */
import React from "react";
import LegalPage from "./LegalPage";

const MARKDOWN = `# watu wako Terms of Use

Last updated: 1 October 2026

## Who we are

watu wako is a Nairobi events app at app.watuwako.com, with a website at watuwako.com. It is run by Watu Wako Collective, Nairobi, Kenya. You can reach us at hello@watuwako.com.

By creating an account or using watu wako, you agree to these terms and to our Privacy Policy at app.watuwako.com/privacy. If you don't agree, please don't use watu wako.

## Who can use watu wako

watu wako is for people aged 18 and over. When you sign up, you confirm you're 18 or older and that what you tell us about yourself is true.

## Your account

- Keep your sign in details to yourself. You're responsible for what happens on your account.
- One account per person. Don't sign up as someone else.
- Tell us at hello@watuwako.com if you think someone else is using your account.
- You can close your account at any time by emailing us.

## Using watu wako well

Be the kind of person people want at their event. Don't:

- post anything false, hateful, threatening, sexual or harassing;
- post someone else's photos, videos or words without the right to;
- write fake reviews or ratings, or rate an event you have a stake in (your own event, a friend's, or a competitor's) to push its score up or down;
- spam, scrape, or try to break into or overload the app;
- use watu wako for anything illegal.

We may remove content or pause or close an account that breaks these rules. Where we can, we'll tell you why.

## What you post

You keep ownership of the reviews, ratings, posts, photos and videos you share. By posting them, you let watu wako show, store and share them inside watu wako and on our website and social pages to promote watu wako, for as long as they're up. You can delete your posts at any time. Reviews and ratings stay on an event without your name if you close your account, so event scores stay fair.

## Events, tickets and organisers

- watu wako lists events. We don't run them, and we don't sell tickets unless we clearly say so.
- Tickets are sold by the curator or their ticketing partner. Your purchase, refunds and entry are between you and them.
- We work to keep listings accurate, but dates, prices, line ups and venues can change. Check with the curator before you go.
- Our scores, picks and awards are our opinions and our members' opinions, not promises about any event.

## Membership and payments

watu wako may offer a paid membership. Before we ever charge you, we'll show you the price and what you get, and ask you to confirm. Payments go through M-Pesa. Trials end on the date we show you, and we won't charge you after a trial unless you choose to pay.

## Our app

We're always improving watu wako, so features may change, pause or stop. We do our best to keep it running, but we can't promise it will always be available or free of mistakes.

## Responsibility

watu wako is provided as it is. To the extent the law allows, Watu Wako Collective isn't responsible for events run by others, for what other members post, or for any loss that comes from relying on a listing, score or review. Nothing in these terms takes away rights you have under Kenyan consumer law.

## Changes to these terms

If we change these terms we'll update the date at the top. If the change is a big one, we'll tell you in the app or by email before it takes effect.

## The law

These terms are governed by the laws of Kenya, and any dispute goes to the courts of Kenya.

## Contact us

Questions about these terms: hello@watuwako.com

Watu Wako Collective, Nairobi, Kenya.
`;

export default function Terms() {
  return <LegalPage title="terms of use · watu wako" markdown={MARKDOWN} />;
}
